import { Photo } from "app/shared/models";

export const isPhoto = (object: any): object is Photo => {
  return "id" in object && "url" in object;
};
